import { atom } from "recoil";

type modalInfo = {
  isOpen: boolean;
};

export const editModalInfoState = atom<modalInfo>({
  key: "editModalInfoState",
  default: {
    isOpen: false,
  }
});